<div *ngIf="showNotification" class="notification">
    <p>Sua conexão será encerrada em <strong class="countdown-color">{{ countdown }}</strong> segundos</p>
</div>
